import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class BroadcastService {

  constructor(private http: HttpClient) { }

  insert_broadcast_message(messageForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `broadcast-message/insert_broadcast_message`, messageForm, OPTIONS)
  }

  get_broadcast_messages() {
    return this.http.get<any>(Library.API_ENDPOINT + 'broadcast-message/get_broadcast_messages', OPTIONS);
  }

  get_broadcast_message_for_user() {
    return this.http.get<any>(Library.API_ENDPOINT + 'broadcast-message/get_broadcast_message_for_user', OPTIONS);
  }

  confirm_message(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `broadcast-message/confirm_broadcast_message/${id}`, OPTIONS)
  }

  delete_broadcast_message(id: any) {
    return this.http.post<any>(Library.API_ENDPOINT + `broadcast-message/delete_broadcast_message/${id}`, OPTIONS)
  }
}
